var map = {
	"./Blossom Stayz Logo.webp": "dd0a",
	"./CAAD.png": "36f9",
	"./Ladli foundation.png": "9a9d",
	"./OasisLogo.jpg": "be3f",
	"./OasisLogo.png": "4ef2",
	"./WEWZone.png": "47a6",
	"./akshaya.png": "6c1d",
	"./bcg workshop.jpg": "f26b",
	"./campus events.png": "dc21",
	"./cityfurnish.png": "32c8",
	"./dears in beers.png": "725f",
	"./decathlon.jpg": "76d7",
	"./eximeng.png": "774e",
	"./high flyer gym.jpg": "7285",
	"./hokosoko.jpg": "fc6a0",
	"./jindal steel.png": "bf57",
	"./pubg2.0.png": "363d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dcb6";